import { useEffect } from 'react'

import { useWebSocket } from '~/shared/components/WebSocketProvider/useWebSocket.ts'

export const useBackChannelLogout = () => {
  const socket = useWebSocket()

  useEffect(() => {
    if (socket) {
      socket.on('logout', () => {
        // we do a window reload here because the backchannel logout server command clears the session data from redis
        // and we need to reload the page to trigger the session handling logic
        globalThis.window.location.reload()
      })
    }
  }, [socket])
}